<template>
    <div>
            <v-dialog v-model="setDefaultDialog" width="280" persistent> 
            <!-- <v-form v-model="validDefault" ref="form"> -->
                <v-card height="350">
        
            <v-toolbar dense color="#4280bd" dark>
            
                    <v-toolbar-title>{{$t('cars.accntInfo')}}</v-toolbar-title>
        
                    <v-spacer></v-spacer>
                <v-btn small icon @click="closeDefaultDialog()" class="mr-0"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
            <v-list-item three-line>
                    <!-- {{carsInfo}} -->
                <v-list-item-content>
            
                <v-list-item-subtitle>
                    <!-- <pre> {{ DropDownListArea }}</pre> -->
                    <!-- DropPoint -->
                    <!-- DropPointDetails -->
                    <v-select  v-model="carsInfo.PickUpPoint" :items = "PickUpList" dense outlined :label = "$t('cars.pickupPoint')" class="mt-2" required style="font-family:Verdana"></v-select>  
                    <v-select v-model="carsInfo.DropPoint" @change="GetDropPointDetail(carsInfo.DropPoint)" :items = "DropDownListArea" dense outlined label = "Address" id="d_DropPoint" class="mt-2" required style="font-family:Verdana"></v-select>       
                    <v-select v-model="carsInfo.DropPointDetails" :items = "DropDownDetailsList" dense outlined label= "Residence"  id="d_DropPoint" class="mt-2" required style="font-family:Verdana"></v-select>
                
                <v-btn @click="saveDefault()"  color="success" block dense  style="font-family:Verdana;font-size:18px">Save</v-btn>
                </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            </v-card>
            <!-- </v-form> -->
        </v-dialog>
            <v-snackbar v-model="snackbarUpdate" :timeout="3000" bottom right  color = "#298f41">  
            <span style = "font-family:Verdana"> Save</span>
        </v-snackbar> 
    </div>
</template>
<script>
// import axios from 'axios'
import api from '../api.js'
export default {
    props:{
        setDefaultDialog:{
            type : Boolean,
            required : true
        },

        carsInfo:{
            type : Object,
            required : true
        },
    },
    watch:{
        setDefaultDialog(val) {
            if(val== true) {
                this.temp.DropPoint =  this.carsInfo.DropPoint
                this.temp.DropPointDetails =  this.carsInfo.DropPointDetails
                this.temp.PickUpPoint = this.carsInfo.PickUpPoint

                setTimeout(() => { // 2026-04-22
                    this.GetDropPointDetail( this.carsInfo.DropPoint)
                }, 800);
            }
        }
    },
    created(){
        this.$store.dispatch('LOAD_DROPPOINT_AREA') // Drop Area ( 2023-02-08)
        this.$store.dispatch('LOAD_DROPPOINT_LIST') // Get All Drop Point List ( 2023-02-08 )
        this.$store.dispatch('LOAD_DROPPOINT') // Drop Detail
        this.$store.dispatch('LOAD_PICKUPPOINT')
        // console.log('line64',this.$store.state.dropPointArrList )
    },
    data(){
        return{
            temp: {},
            snackbarUpdate : false,
            toSave: {},
            DropDownDetailsList: []
        }
    },
    computed:{
        DropDownListArea() {  // Drop Area ( 2023-02-08)
            return this.$store.getters.DropDownListArea
        },
        // DropDownList(){  // Drop Detail
        //     return  this.$store.getters.DropDownList
        // },

        PickUpList(){
            return this.$store.getters.PickUpList
        }
    },
    methods:{
        GetDropPointDetail( drop_area) {
            this.DropDownDetailsList = []
            let tmpOthers = "OTHER"
            if( drop_area ) {
                this.DropDownDetailsList = this.$store.state.dropPointArrList.filter(rec=>{
                    return rec.PointNameArea == drop_area && rec.PointName != 'OTHER'
                }).map(rec1=>{ return rec1.PointName})
                    .sort((a,b) =>{ return a > b ? 1 : -1})
                
                this.DropDownDetailsList.push( tmpOthers );
            }

        
        },
        closeDefaultDialog(){
            this.carsInfo.DropPoint = this.temp.DropPoint
            this.carsInfo.DropPointDetails = this.temp.DropPointDetails
            this.carsInfo.PickUpPoint = this.temp.PickUpPoint
            this.$emit('closeDefaultDialog')
        },
        saveDefault(){
          // this.toSave = this.carsInfo 
            console.log('line112',this.carsInfo)
            const url = `${this.api}updateCARS_AreaResidence`
            
            // alert(url)
                // const url = "http://10.169.141.125:3000/updateCARS_AreaResidence"
                api.put(url,
                {"id": this.carsInfo.id, 
                "PickUpPoint": this.carsInfo.PickUpPoint, 
                "DropPoint": this.carsInfo.DropPoint, 
                "DropPointDetails": this.carsInfo.DropPointDetails }).then(res =>{
                console.log(res.data)
                this.snackbarUpdate = true
            }).catch(err =>{
                console.log(err)    
            })

            // const url2 = `${this.api}updateCARS_AreaResidence`
            // api.put
            this.$emit('closeDefaultDialog')
        }
    }
}
</script>